import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../Utils/axiosInstance";

const initialStateAbout= {
    about: {},
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getAboutsMetrics = createAsyncThunk(
    "about/getAboutsMetrics",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/getAboutsMetrics`);
            return response.data.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const aboutSlice = createSlice({
    name: 'about',
    initialState: initialStateAbout,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAboutsMetrics.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching users...';
            })
            .addCase(getAboutsMetrics.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Blog fetched successfully';
                state.about = action.payload;
            })
            .addCase(getAboutsMetrics.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch users';
            })
    }
});

export default aboutSlice.reducer;